import ListingAvailabilities from './ListingAvailabilities';

export default ListingAvailabilities;
